import BitesApi from '../index';

export const fetchOrganiztionTeamUsers = (organizationId: number) =>
  BitesApi.get(`/organizations/${organizationId}/teams_users/`);
